import { BILLING_DOMAIN, type BillingClientSecret, type BillingInvoice, type BillingInvoiceLinks, type BillingSettings } from "@finway-group/shared/lib/models"
import axios from "axios"

export const BillingSettingsService = {
    getInvoiceLinks: async (invoice: BillingInvoice) => {
        const { data } = await axios.post<BillingInvoiceLinks>(`${BILLING_DOMAIN}/invoices/${invoice.invoiceId}/links`)
        return data
    },
    getClientSecret: async () => {
        const { data } = await axios.post<BillingClientSecret>(`${BILLING_DOMAIN}/secret`)
        return data.clientSecret
    },
    savePaymentMethod: async (paymentMethodId: any) => {
        const { data } = await axios.post<BillingSettings>(`${BILLING_DOMAIN}/payment-method`, { paymentMethodId })
        return data
    },
}
